import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="w-full bg-[#3E2B1F] py-12 md:py-16" data-id="element-96">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-98">
          <h3 className="font-serif text-2xl font-bold text-[#F7F2EA] mb-4 tracking-widest uppercase" data-id="element-99">
            RECURSOHUB™
          </h3>
          <p className="text-lg text-[#E7DDD2] font-medium mb-2" data-id="element-100">
            El sistema N°1 para emprender con minidonas desde casa en Argentina
          </p>
          <p className="text-[#E7DDD2]/70 text-base mb-8" data-id="element-101">
            Porque emprender no debería costar años de prueba y error.
          </p>
          <div className="text-[#F7F2EA] text-base mb-8 space-y-2" data-id="element-102">
            <p data-id="element-103">📧 atencionrecursohub@gmail.com</p>
            <p data-id="element-104">🌐 www.recursohub.com</p>
          </div>
          <div className="text-sm text-[#E7DDD2]/50 mb-8 space-y-1" data-id="element-105">
            <p data-id="element-106">© recursoHUB™ 2026 — Todos los derechos reservados.</p>
            <p data-id="element-107">
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>
          <p className="font-serif text-2xl font-bold text-[#B66A2C] italic" data-id="element-108">
            "La próxima semana puede ser diferente."
          </p>
        </motion.div>
      </div>
    </footer>;
}